import { render, staticRenderFns } from "./IconVegetarian.vue?vue&type=template&id=199c2f64&"
import script from "./IconVegetarian.vue?vue&type=script&lang=js&"
export * from "./IconVegetarian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports